import AsoHeader from '../../../components/Aso/Header';
import AsoValidarTelefone from '../../../components/Aso/Register/AsoValidarTelefone';

const AsoRegistroValidarTelefone: React.FC = () => {

  return (
    <div>
      <AsoHeader />
      <AsoValidarTelefone />
    </div>
  );
}

export default AsoRegistroValidarTelefone;